<template>
  <div class="services-product">
    <div class="title">{{ $t('serviceSupport.servicesProduct3.title') }}</div>
    <div class="content-item">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct3.definition') }}</div>
      <div class="content-info">{{ $t('serviceSupport.servicesProduct3.definitionContent') }}</div>
    </div>
    <div class="content-item">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct3.mainTypes') }}</div>
      <div class="content-table">
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="productType"
            :label="$t('serviceSupport.servicesProduct3.tableColumns.productType')"
            width="199">
          </el-table-column>
          <el-table-column
            prop="query"
            :label="$t('serviceSupport.servicesProduct3.tableColumns.typicalForm')"
            width="500">
          </el-table-column>
          <el-table-column
            prop="applicableScenario"
            :label="$t('serviceSupport.servicesProduct3.tableColumns.characteristics')"
            width="500"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="content-item">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct3.performanceParameters') }}</div>
      <div class="content-li" v-for="(item, index) in performanceParams" :key="index">
        <div class="content-li-item">
          <div class="li-left">
            <span></span>
            <div class="li-left-title">{{ item.title }}</div>
          </div>
          <div class="li-right">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="content-item">
      <div class="content-title">{{ $t('serviceSupport.servicesProduct3.selectionPoints') }}</div>
      <div class="content-li" v-for="(item, index) in selectionCriteria" :key="index">
        <div class="content-li-item">
          <div class="li-left">
            <span></span>
            <div class="li-left-title">{{ item.title }}</div>
          </div>
          <div class="li-right">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    tableData () {
      return this.$t('serviceSupport.servicesProduct3.tableData')
    },
    performanceParams () {
      return this.$t('serviceSupport.servicesProduct3.performanceParams')
    },
    selectionCriteria () {
      return this.$t('serviceSupport.servicesProduct3.selectionCriteria')
    }
  }
}
</script>

<style lang="scss" scoped>
.services-product {
  width: 1200px;
  margin: 0 auto;
  padding: 100px 0;
  .title {
    font-weight: 600;
    font-size: 40px;
    line-height: 56px;
    text-align: center;
    padding-bottom: 80px;
  }
  .content-item {
    padding-bottom: 80px;
    .content-title {
      font-weight: 500;
      font-size: 24px;
      line-height: 34px;
      padding-bottom: 24px;
    }
    .content-info {
      font-weight: 400;
      font-size: 18px;
      line-height: 32px;
      color: rgba(43, 50, 71, 0.7);
    }
  }
  .content-li {
    padding-bottom: 30px;
    &:last-child {
      padding-bottom: 0;
    }
    .content-li-item {
      display: flex;
      align-items: center;
      .li-left {
        display: flex;
        align-items: center;
        span {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: rgb(43, 50, 71);
          margin-right: 8px;
        }
        .li-left-title {
          font-weight: 400;
          font-size: 18px;
          line-height: 25px;
        }
      }
      .li-right {
        color: rgba(43, 50, 71, 0.7);
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
      }
    }
  }
  .content-table {
    ::v-deep .el-table__header th {
      color: rgb(34, 34, 34);
    }
    ::v-deep .el-table__body td {
      color: rgba(43, 50, 71, 0.7);
    }
  }
}
</style>